import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeService from '../../../Services/OfficeService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. OfficeAdmin always passes the selected office (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class OfficeEmployeeCostsEditItem {}

export default class EditOfficeEmployeeWindowDescription {
  static titleForEdit = (item) => `Edit Employee Cost Information (${item.Name})`;
  static itemType = OfficeEmployeeCostsEditItem;
  static finishButtonLabel = 'Save Office';
  static messageOnSuccess = 'Office has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: the whole edited office object is posted back
  // (OfficeService.EditOffice string-converts and PUTs the entire office). MUST return the
  // promise (wizard contract).
  static serviceFunction = (edited) => OfficeService.EditOffice(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OperationsMgrDailyCost',
          label: 'Operations Mgr Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'TeamLeadDailyCost',
          label: 'Senior Project Mgr Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PanelMgrRecruiterDailyCost',
          label: 'Recruiter Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ProjMgrDailyCost',
          label: 'Project Mgr Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'EditDataCheckDailyCost',
          label: 'Datachecker Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AssistantProjMgrDailyCost',
          label: 'Assistant Project Mgr Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'BidailyCost',
          label: 'BI Daily Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OverheadDailyCost',
          label: 'Overhead Daily Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
